import React from "react";
import "./Incoterms.css";

const Incoterms = () => {
  return (
    <div className='incotermsinfo'>
      <h4>Incoterms 2020</h4>
      <div className='incotermcols'>
        <div>
          <h4>EXW - Ex Works (Named Place)</h4>
          <ul>
            <li>
              <b>Delivery Point:</b> Seller makes the goods available at their premises (factory, warehouse, etc.).
            </li>
            <li>
              <b>Risk transfers:</b> As soon as goods are placed at disposal of buyer (before loading).
            </li>
            <li>
              <b>Buyer's job:</b> Buyer handles everything (loading, export customs, transport, insurance, import
              clearance).
            </li>
            <li>
              <b>Use case:</b> Maximum responsibility on buyer. Often avoided in international trade because buyer may
              struggle with export clearance.
            </li>
          </ul>
          <h4>FCA - Free Carrier (Named Place)</h4>
          <ul>
            <li>
              <b>Delivery point:</b> Seller delivers goods to carrier or another party nominated by buyer at seller's
              premises or another named place.
            </li>
            <li>
              <b>Risk transfers: </b>Once goods are handed over to the carrier, loaded.
            </li>
            <li>
              <b>Use case: Flexible</b> — can be used for trucks, containers at a terminal, airport cargo, etc.
              Preferred over FOB for containerized cargo.
            </li>
          </ul>
          <h4>CPT - Carriage Paid To (Named Destination)</h4>
          <ul>
            <li>
              <b>Delivery point:</b> Seller delivers goods to carrier at agreed place (origin).
            </li>
            <li>
              <b>Seller's cost: </b>Seller pays for transport to named destination.
            </li>
            <li>
              <b>Risk transfers:</b> When goods are handed to first carrier (not at destination).
            </li>
            <li>
              <b>Use case:</b> Buyer gets benefit of seller arranging transport, but risk transfers much earlier.
            </li>
          </ul>
          <h4>CIP - Carriage and Insurance Paid To (Named Destination)</h4>
          <ul>
            <li>
              <b>Delivery point:</b> Same as CPT, but seller also arranges and pays for insurance covering buyer's risk
              during carriage.
            </li>

            <li>
              <b>Insurance requirement:</b> Seller must provide insurance with Institute Cargo Clauses (A) — broadest
              coverage.
            </li>

            <li>
              <b>Risk transfers:</b> Still at origin handover to first carrier.
            </li>

            <li>
              <b>Use case: </b>Buyer gets more security since insurance is included.
            </li>
          </ul>
          <h4>DAP - Delivered At Place (Named Place of Destination) </h4>
          <ul>
            <li>
              <b>Delivery point:</b> Seller delivers goods ready for unloading at named place in destination country
              (e.g., warehouse, distribution center, border point).
            </li>
            <li>
              <b>Risk transfers:</b> At arrival, before unloading.
            </li>
            <li>
              <b>Seller's job:</b> Export clearance + carriage to destination
            </li>
            <li>
              <b>Buyer's job:</b> Import customs + duties.{" "}
            </li>
            <li>
              <b>Use case:</b> Buyer wants door-to-door delivery but will handle import formalities.
            </li>
          </ul>
          <h4>DPU - Delivered at Place Unloaded (Named Place of Destination)</h4>
          <ul>
            <li>
              <b>Delivery point:</b> Seller delivers goods unloaded at destination place (terminal, warehouse, etc.).
            </li>

            <li>
              <b>Risk transfers:</b> After unloading at destination.
            </li>

            <li>
              <b>Key difference vs DAP:</b> Seller bears responsibility for unloading.
            </li>

            <li>
              <b>Use case:</b> Best when seller has better logistics setup at buyer's terminal.
            </li>
          </ul>
        </div>
        <div>
          <h4>DDP - Delivered Duty Paid (Named Place of Destination) </h4>
          <ul>
            <li>
              <b>Delivery point:</b> Goods delivered ready for unloading at destination, with all import duties, taxes,
              customs clearance paid by seller.
            </li>
            <li>
              <b>Risk transfers:</b> After arrival at named place.{" "}
            </li>
            <li>
              <b>Seller's responsibility:</b> Maximum — covers everything door-to-door, including import.
            </li>
            <li>
              <b>Use case:</b> Seller offers “landed cost” delivery. Risky for seller if unfamiliar with buyer's
              country's import rules.
            </li>
          </ul>
          <h4>FAS - Free Alongside Ship (Port of Shipment)</h4>

          <ul>
            <li>
              <b>Delivery point:</b> Seller delivers goods placed alongside the vessel (e.g., at quay, barge, dock) at
              the origin port.
            </li>

            <li>
              <b>Risk transfers:</b> Once goods are physically alongside the ship.
            </li>

            <li>
              <b>Seller's job:</b> Export clearance + bring goods to quay.
            </li>

            <li>
              <b>Buyer's job:</b> Loading onto vessel, freight, insurance, import.
            </li>

            <li>
              <b>Use case:</b> Bulk commodities (grain, coal, oil) where loading is buyer's responsibility.
            </li>
          </ul>

          <h4>FOB - Free On Board (Port of Shipment)</h4>

          <ul>
            <li>
              <b>Delivery point:</b> Seller delivers goods on board the vessel at the origin port.
            </li>

            <li>
              <b>Risk transfers:</b> Once goods are loaded onto the ship.
            </li>

            <li>
              <b>Seller's job:</b> Export clearance + loading onto vessel.
            </li>

            <li>Buyer's job: Main carriage (ocean freight), insurance, import.</li>

            <li>
              <b>Use case:</b> Traditional for bulk shipments, but not recommended for containerized cargo (use FCA
              instead).
            </li>
          </ul>

          <h4>CFR - Cost and Freight (Port of Destination)</h4>
          <ul>
            <li>
              <b>Delivery point:</b> Seller delivers goods on board vessel at origin port.
            </li>

            <li>
              <b>Seller's cost:</b> Pays for ocean freight to named destination port.
            </li>

            <li>
              <b>Risk transfers:</b> When goods are loaded at origin port (not at arrival!).
            </li>

            <li>
              <b>Buyer's job:</b> Insurance, unloading, import clearance.
            </li>

            <li>
              <b>Use case:</b> Large-volume seaborne trade (steel, raw materials).
            </li>
          </ul>

          <h4>CIF - Cost, Insurance & Freight (Port of Destination)</h4>

          <ul>
            <li>
              <b>Delivery point:</b> Same as CFR, but seller also arranges and pays for marine insurance (minimum
              Institute Cargo Clauses (C) coverage).
            </li>

            <li>
              <b>Delivery point:</b> Still at origin port, when goods are loaded on board.
            </li>

            <li>
              <b>Risk transfers:</b> On loading, even though seller pays for insurance and freight.
            </li>

            <li>
              <b>Use case:</b> Common in commodity trade where insurance is standardized.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Incoterms;
